import { render, staticRenderFns } from "./UnreportedVehicle.vue?vue&type=template&id=1b1b58f6&"
import script from "./UnreportedVehicle.vue?vue&type=script&lang=js&"
export * from "./UnreportedVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports